'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _UILink = require('UIComponents/link/UILink');

var _UILink2 = _interopRequireDefault(_UILink);

var _UIFileButton = require('UIComponents/button/UIFileButton');

var _UIFileButton2 = _interopRequireDefault(_UIFileButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FilePickerLink = function FilePickerLink(props) {
  return _react2.default.createElement(
    _UIFileButton2.default,
    {
      use: 'unstyled',
      onClick: props.onClick,
      onChange: props.onChange
    },
    _react2.default.createElement(
      _UILink2.default,
      { use: 'on-bright' },
      props.children
    )
  );
};

FilePickerLink.propTypes = {
  children: _react.PropTypes.node.isRequired,
  onChange: _react.PropTypes.func.isRequired,
  onClick: _react.PropTypes.func
};

exports.default = FilePickerLink;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/components/FilePickerLink.js
// module id = 1173
// module chunks = 2 3